// src/components/Slider/TextOnlySwiper.jsx
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y, Keyboard, Autoplay } from "swiper/modules";
import "swiper/css";
import "./slider.css";

import leftArrow from "../../assets/images/leftArrow.svg";
import rightArrow from "../../assets/images/rightArrow.svg";

const SLIDES = [
  "Технология True-Color Holography  позволяет экрану сохранять неоновую яркость даже под прямыми лучами солнца",
  "Жидкость CODE - результат работы лучшей лаборатории Европы. Благодаря технологии Flavor Lock Matrix вкус CODE остается насыщенным до самой последней затяжки",
  "Технология AIRFLOW CONTROL PRO позволяет вам выбрать именно тот поток воздуха, который вы хотите. CODE не приемлет никаких ограничений в вопросе вашего удовольствия ",
  "Металический корпус устройства выполнен  в цвете Imperial Purple, разработанным международным институтом цвета Pantone",
  "Керамическое напыление защищает CODE от любых повреждений. Мы красим каждый девайс вручную, используя самые качественные краски европейского производства",
];

export default function TextOnlySwiper() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (
      swiperRef.current &&
      swiperRef.current.params &&
      prevRef.current &&
      nextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <div className="toswiper">
      <Swiper
        modules={[Navigation, A11y, Keyboard, Autoplay]}
        slidesPerView={1}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        keyboard={{ enabled: true }}
        allowTouchMove
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={450}
        loop
      >
        {SLIDES.map((text, i) => (
          <SwiperSlide key={i}>
            <div className="toswiper__text">{text}</div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="toswiper__nav toswiper__nav--left">
        <button ref={prevRef} aria-label="Prev" className="toswiper__btn">
          <img src={leftArrow} alt="" className="toswiper__icon" />
        </button>
        <button ref={nextRef} aria-label="Next" className="toswiper__btn">
          <img src={rightArrow} alt="" className="toswiper__icon" />
        </button>
      </div>
    </div>
  );
}
